export default "__VITE_ASSET__86811109__"